export interface VirtualIdentity {
  uid: string;
  typeName: VirtualIdentityType;
  emailAddress: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export enum VirtualIdentityType {
  Yapeal = 'YapealIdentity',
  Ebill = 'EBillIdentity',
  EbillBusiness = 'EBillBusinessIdentity',
  VT = 'VTIdentity',
  Wise = 'WiseIdentity'
}
